export enum CreditsStatuses {
  Available = "available",
  Reserved = "reserved",
  RemainingOverdraft = "remaining overdraft",
  Inactive = "inactive",
  OverDraft = "overdraft",
  Balance = "balance"
}

export enum MonthStringType {
  Short = "short",
  Long = "long"
}

export enum PeriodType {
  Custom = "custom",
  Previous = "previous"
}

export enum CREDITS_HEALTH {
  Healthy = "Healthy",
  InOverdraft = "InOverdraft",
  LimitReached = "LimitReached",
  LowCredits = "LowCredits",
  OverdraftLimitReached = "OverdraftLimitReached"
}

export enum CREDIT_BEHAVIOUR_COLUMNS {
  CreditBehaviour = "credit behaviour",
  Device = "device",
  VehicleStatus = "vehicle status"
}
